import React from 'react';

const UserInitialsAvatar = ({ first_name, last_name, style }) => {
    const initials = `${first_name?.charAt(0) || ''}${last_name?.charAt(0) || ''}`.toUpperCase();

    const stringToColor = (string) => {
        let hash = 0;
        for (let i = 0; i < string.length; i++) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = '#';
        for (let i = 0; i < hash.length || i < 3; i++) {
            const value = (hash >> (i * 8)) & 0xFF;
            color += ('00' + value.toString(16)).substr(-2);
        }
        return color.substring(0, 7);
    };

    return (
        <div style={{
            ...style,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: stringToColor(`${first_name}${last_name}`),
            color: '#ffffff',
            fontWeight: 'bold',
            fontSize: '1.2rem',
            borderRadius: '50%',
            overflow: 'hidden'
        }}>
            {initials}
        </div>
    );
};

export default UserInitialsAvatar;